const pl = {
    dashboard: "Panel główny",
    glossary: "Słownik",
    profile: "Profil",
    courses: "Kursy",
    settings: "Ustawienia",
    law: "Prawo popytu i podaży",
    ppc: "Krzywa możliwości produkcyjnych",
    consumer: "Wybór konsumenta",
    nextLesson: "Następna lekcja",
    startQuiz: "Rozpocznij quiz",
    finishCourse: "Zakończ kurs",
  };
  
  export default pl;
